import DataBinding from '../base/data-binding.js';
import { EventHandler, getParameterByName } from '../../base/utils.js';
import Form from '../base/form.js';
import GoFastGoFree from './gofast-gofree-accrued.js';
import Spinner from './spinner.js';
import UserHandler from '../base/user.js';
import { requestUrls, REDIRECT_URL } from '../../base/vars.js';
import { setLocalStorage } from '../../base/session-handler.js';

const fileTypes = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/gif',
  'application/vnd.ms-xpsdocument'
];

const fileExtensions = [
  /\.pdf$/i,
  /\.jpg$/i,
  /\.png$/i,
  /\.gif$/i,
  /\.xps$/i
];

class Claim {
  constructor() {
    this.$goldPassForm = $('#claimGoldGoldPassId');
    this.$goldPassId = $('#goldPassId'); // Min length 20; max length 22
    this.$wvoForm = $('#claimGoldWvo');
    this.$ownerNumber = $('#ownerNumber');
    this.$wwaForm = $('#claimGoldWwa');
    this.$competitorProgramName = $('#competitorMatchProgram');
    this.$businessUnit = $('#businessUnit');
    this.$associateTitle = $('#associateTitle');
    this.$supervisorName = $('#supervisorName');
    this.$claimPointsForm = $('#claimPoints');
    this.$couponCode = $('#couponCode');
    this.$memberIdentifier = $('[data-binding="Channel.WR.MembershipID"]');
    this.$caesarsStatusMatch = $('#statusMatch');
    this.$caesarsMemberNumber = $('#caesarsMemberNumber'); // TODO, tech debt in a future sprint this should be refactored to use accountNumber
    this.$loyaltyStatusMatch = $('#loyaltyStatusMatch');
    this.$caesarsZipCode = $('#zipCode0');
    this.$isoDateOfBirth = $('#isoDateOfBirth');
    this.$form = $('#competitorMatchProgram');
    this.$file = '';
    this.$claimMember = $('#claim');
    this.isMilitary = $('#claim').data('claim-type') && $('#claim').data('claim-type').toLowerCase() === 'military';
    this.$accountNumber = $('#accountNumber');

    $(document).one('user:profile:update', () => {
      this.determineFormType();
    });

    this.updatePromoJoinButton();
  }

  updatePromoJoinButton() {
    const joinButton = $('a[href*="?promo"]');

    if (joinButton.length > 0) {
      const href = window.location.href;
      localStorage.removeItem(REDIRECT_URL);
      
      joinButton.on('click', (e) => {
        setLocalStorage(REDIRECT_URL, {url: href});
      });
    }
  }

  determineFormType() {
    if (this.$goldPassForm.length > 0 && this.$goldPassId.length > 0 && requestUrls.goldPassId) {
      this.handleGoldPassForm();
    }
    if (this.$competitorProgramName.length > 0 && requestUrls.wrContactUs && requestUrls.wrFileUpload) {
      this.handleCompetitorStatusForm();
    }
    if (this.$wvoForm.length > 0 && this.$ownerNumber.length > 0 && requestUrls.genericClaim) {
      this.handleWvoForm();
    }
    if (this.$wwaForm.length > 0 && this.$businessUnit.length > 0 && this.$associateTitle.length > 0 &&
      this.$supervisorName.length > 0 && requestUrls.genericClaim) {
      this.handleWwaForm();
    }
    if (this.$claimPointsForm.length > 0 && (this.$couponCode.length > 0 || this.$accountNumber.length > 0) && requestUrls.claimPoints) {
      this.handleClaimPointsForm();
    }
    if (this.$caesarsStatusMatch.length > 0 && this.$caesarsMemberNumber.length > 0 && this.$caesarsZipCode.length > 0 && this.$isoDateOfBirth.length > 0 && requestUrls.statusMatch) {
      this.handleCaesarsStatusMatchForm();
    }
    if (this.$loyaltyStatusMatch.length > 0 && requestUrls.genericClaim) {
      this.handleGenericClaimForm();
    }
    if (this.$claimMember.length > 0 && requestUrls.genericClaim) {
      this.handleMemberClaimForm();
    }
  }

  handleGoldPassForm() {
    this.scrollToTop();

    let opts = {
      url: requestUrls.goldPassId,
      validation: {
        live: 'submitted',
        fields: {
          goldPassId: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="goldPassId"]').text()
              },
              stringLength: {
                min: 20,
                max: 22,
                message: $('[data-fv-validator="stringLength"][data-fv-for="goldPassId"]').text()
              }
            }
          }
        }
      }
    };
    this.initClaimForm(this.$goldPassForm, opts);
  }

  handleCompetitorStatusForm() {
    if (this.$form.find('#emailAddress').val().length > 0) {
      this.$form.find('#emailAddress').parent()
        .addClass('hidden');
      this.$form.find('.email.locked-text-input').removeClass('hidden');
      this.$form.find('#emailAddress').parent()
        .addClass('hidden')
        .addClass('disabled');
    }
    this.scrollToTop();
    this.$form.find('.member-input').addClass('hidden');
    this.$form.find('.file-upload')
      .on('click', (e) => this.handleFileUploadClick(e))
      .on('change', '#fileId', () => this.handleFileUpload());
    this.$form.find('.file-remove').on('click', (e) => this.resetFileUpload(e));
    let opts = {
      url: requestUrls.wrContactUs,
      validation: {
        live: 'submitted',
        fields: {
          programStatus: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="programStatus"]').text()
              }
            }
          },
          competitorProgramName: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="competitorProgramName"]').text()
              }
            }
          },
          emailAddress: {
            validators: {
              regexp: {
                regexp: /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/
              },
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="emailAddress"]').text()
              }
            }
          }
        }
      }
    };
    this.initCompetitorStatusForm(this.$competitorProgramName, opts);
  }

  handleWvoForm() {
    this.scrollToTop();
    let opts = {
      url: requestUrls.genericClaim,
      ignoredInputs: 'input:not([name=ownerNumber])',
      validation: {
        live: 'submitted',
        fields: {
          ownerNumber: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="ownerNumber"]').text()
              },
            }
          }
        }
      }
    },
    cbs = {
      preprocess: () => {
        let $bonusCode = $(document.createElement('input')),
          $aliasType = $(document.createElement('input')),
          $alias = $(document.createElement('input')),
          claimType = this.$wvoForm.data('claim-type');
        if (!claimType) {
          claimType = 'WVO';
        }
        $bonusCode.attr('type', 'hidden').attr('value', claimType).attr('name', 'bonusCode');
        $aliasType.attr('type', 'hidden').attr('value', claimType).attr('name', 'aliasType');
        $alias.attr('type', 'hidden').attr('value', $('#ownerNumber').val()).attr('name', 'alias');
        this.$wvoForm.append($bonusCode).append($aliasType).append($alias);
      }
    };
    this.initClaimForm(this.$wvoForm, opts, cbs);
  }

  handleWwaForm() {
    this.scrollToTop();
    let opts = {
      url: requestUrls.genericClaim,
      ignoredInputs: 'input:not([name=businessUnit],[name=associateTitle],[name=supervisorName])',
      validation: {
        live: 'submitted',
        fields: {
          businessUnit: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="businessUnit"]').text()
              },
            }
          },
          associateTitle: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="associateTitle"]').text()
              },
            }
          },
          supervisorName: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="supervisorName"]').text()
              },
            }
          },
        }
      }
    },
    cbs = {
      preprocess: () => {
        let $bonusCode = $(document.createElement('input')),
          claimType = this.$wwaForm.data('claim-type');
        if (!claimType) {
          claimType = 'WWA';
        }
        $bonusCode.attr('type', 'hidden').attr('value', claimType).attr('name', 'bonusCode');
        this.$wwaForm.append($bonusCode);
      }
    };
    this.initClaimForm(this.$wwaForm, opts, cbs);
  }

  handleClaimPointsForm() {
    this.scrollToTop();
    let opts = {
      url: requestUrls.claimPoints,
      validation: {
        live: 'submitted',
        fields: {
          couponCode: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="couponCode"]').text()
              },
            }
          },
          accountNumber: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="accountNumber"]').text()
              },
            }
          },
        }
      }
    },
      cbs = {
        success: (response) => {
          DataBinding.renderData({
            ClaimPoints: {
              PointsEarned: response.pointsEarned
            }
          }, '[data-binding^=ClaimPoints]');
          GoFastGoFree.populateAccruedRewards();
        }
      };

    if (this.$memberIdentifier.length > 0) {
      opts.validation.fields.memberIdentifier = {
        validators: {
          notEmpty: {
            enabled: true,
            message: $('[data-fv-validator="notEmpty"][data-fv-for="memberIdentifier"]').text()
          },
        }
      };
    }

    this.initClaimForm(this.$claimPointsForm, opts, cbs);
    this.$couponCode.val(getParameterByName('voucherNumber')).change()
      .on('blur', (e) => {
        let voucher = $(e.currentTarget).val();
        if (voucher !== '') {
          EventHandler.triggerEvent('claim-voucher', {
            voucher,
          });
        }
      });
  }

  handleCaesarsStatusMatchForm() {
    this.scrollToTop();
    let opts = {
      url: requestUrls.statusMatch,
      ignoredInputs: 'select:not([name=birthDay],[name=birthMonth],[name=birthYear]),input:not([name=emailAddress],[name=zipCode0],[name=username],[name=caesarsMemberNumber])',
      validation: {
        live: 'submitted',
        excluded: '',
        fields: {
          caesarsMemberNumber: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="caesarsMemberNumber"]').text()
              }
            }
          },
          emailAddress: {
            validators: {
              regexp: {
                regexp: /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/,
                message: $('[data-fv-validator="regexp"][data-fv-for="emailAddress"]').text()
              },
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="emailAddress"]').text()
              }
            }
          },
          zipCode0: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="zipCode0"]').text()
              },
            }
          },
          birthMonth: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="birthMonth"]').text()
              }
            }
          },
          birthDay: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="birthDay"]').text()
              }
            }
          },
          birthYear: {
            validators: {
              notEmpty: {
                enabled: true,
                message: $('[data-fv-validator="notEmpty"][data-fv-for="birthYear"]').text()
              }
            }
          }
        }
      }
    },
      cbs = {
        preprocess: () => {
          let $email = $(document.createElement('input')),
            $zip = $(document.createElement('input')),
            $accountNumber = $(document.createElement('input'));
          $email.attr('type', 'hidden').attr('value', $('#emailAddress').val())
            .attr('name', 'email');
          $zip.attr('type', 'hidden').attr('value', $('#zipCode0').val())
            .attr('name', 'zip');
          $accountNumber.attr('type', 'hidden').attr('value', $('#caesarsMemberNumber').val())
            .attr('name', 'partnerAccountNumber');
          this.$caesarsStatusMatch.append($email).append($zip).append($accountNumber);
        }
      };
    let $caesarsMemberNumber = $('#caesarsMemberNumber');
    if ($caesarsMemberNumber.data('length-max') || $caesarsMemberNumber.data('length-min')) {
      const maxLength = $caesarsMemberNumber.data('length-max') || 50,
        minLength = $caesarsMemberNumber.data('length-min') || 1;

      opts.validation.fields.caesarsMemberNumber.validators.stringLength = {
        min: minLength,
        max: maxLength,
        message: $('[data-fv-validator="stringLength"][data-fv-for="caesarsMemberNumber"]').text()
      };
    }
    this.initClaimForm(this.$caesarsStatusMatch, opts, cbs);
  }

  handleGenericClaimForm() {
    this.scrollToTop();
    let $email = this.$loyaltyStatusMatch.find('#emailAddress');
    let $account = this.$loyaltyStatusMatch.find('#accountNumber');
    const accountMinLength = $account[0].getAttribute('data-length-min') > 0 ? $account[0].getAttribute('data-length-min') : 1,
      accountMaxLength = $account[0].getAttribute('data-length-max') > 0 ? $account[0].getAttribute('data-length-max') : 300;
    let opts = {
      url: requestUrls.genericClaim,
      ignoredInputs: 'input:not([name=emailAddress],[name=accountNumber],[name=memberNumber],[name=username])',
      validation: {
        live: 'submitted',
        excluded: ''
      }
    },
      cbs = {
        preprocess: ($form) => {
          let $bonusCode = $(document.createElement('input')),
            $aliasType = $(document.createElement('input')),
            $alias = $(document.createElement('input')),
            claimType = this.$loyaltyStatusMatch.data('claim-type') || '',
            aliasType = this.$loyaltyStatusMatch.data('alias-type') || '',
            aliasVal = $('#accountNumber').val() || $('#emailAddress').val() || $('#memberNumber').val() || '';
          $bonusCode.attr('type', 'hidden').attr('value', claimType).attr('name', 'bonusCode');
          $alias.attr('type', 'hidden').attr('value', aliasVal).attr('name', 'alias');
          this.$loyaltyStatusMatch.append($bonusCode).append($alias);  

          if (aliasType) {
            $aliasType.attr('type', 'hidden').attr('value', aliasType).attr('name', 'aliasType');
            this.$loyaltyStatusMatch.append($aliasType);
          }
        }
      };

    if ($account.length > 0) {
      this.$loyaltyStatusMatch.formValidation('addField', $account, {
        trigger: 'blur',
        validators: {
          notEmpty: {
            enabled: true,
            message: $('[data-fv-validator="notEmpty"][data-fv-for="accountNumber"]').text()
          },
          stringLength: {
            min: accountMinLength,
            max: accountMaxLength,
            message: $('[data-fv-validator="stringLength"][data-fv-for="accountNumber"]').text()
          }
        }
      });
    }

    if ($email.length > 0) {
      let emailErrorMessage = $($email.parent().find('.help-block')[0]).text();

      this.$loyaltyStatusMatch.formValidation('addField', $email, {
        validators: {
          regexp: {
            regexp: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
          },
          notEmpty: {
            enabled: true,
            message: emailErrorMessage
          },
          stringLength: {
            min: 6,
            max: 300
          }
        }
      });
    }
    this.initClaimForm(this.$loyaltyStatusMatch, opts, cbs);
  }

  handleMemberClaimForm() {
    this.scrollToTop();
    let opts = {
        url: requestUrls.genericClaim,
        ignoredInputs: 'input:not([name=flexFieldOne],[name=flexFieldTwo])',
        validation: {
          live: 'submitted',
          fields: {
            flexFieldOne: {
              validators: {
                notEmpty: {
                  enabled: true,
                  message: $('[data-fv-validator="notEmpty"][data-fv-for="flexFieldOne"]').text()
                },
              }
            },
            flexFieldTwo: {
              validators: {
                notEmpty: {
                  enabled: true,
                  message: $('[data-fv-validator="notEmpty"][data-fv-for="flexFieldTwo"]').text()
                },
              }
            }
          }
        }
      },
      cbs = {
        preprocess: ($form) => {
          let $bonusCode = $(document.createElement('input'));
          const claimType = this.$claimMember.data('claim-type');
          $bonusCode.attr('type', 'hidden').attr('value', claimType).attr('name', 'bonusCode');
          this.$claimMember.append($bonusCode);
        },
        setPayload: ($form, formData) => {
          const flexFieldOne = $form.find('#flexFieldOne'),
            flexFieldTwo = $form.find('#flexFieldTwo'),
            fieldObjectOne = {
              preferenceRuleCode: flexFieldOne.data('rule-code'),
              preferenceRuleDetailCode: flexFieldOne.data('detail-code'),
              value: flexFieldOne.val()
            }, 
            fieldObjectTwo = {
              preferenceRuleCode: flexFieldTwo.data('rule-code'),
              preferenceRuleDetailCode: flexFieldTwo.data('detail-code'),
              value: flexFieldTwo.val()
            },
            preferences = [fieldObjectOne, fieldObjectTwo];
            formData.preferences = preferences;
        } 
      };
    this.initClaimForm(this.$claimMember, opts, cbs);
  }

  initClaimForm($form, opts, cbs) {
    cbs = cbs || {};

    $('.page').addClass('status-match-page');

    this.removeFormFieldBorder();

    $form
      .formValidation(opts.validation)
      .on('success.form.fv', (e) => {
        e.preventDefault();

        if (typeof cbs.preprocess === 'function') {
          cbs.preprocess($form);
        }

        let formData;
        if(opts.url === requestUrls.statusMatch) {
          let serializeData = Form.serialize($form, false, opts.ignoredInputs);

          let parseData = JSON.parse(serializeData);
          if(parseData && !parseData.optIn) {
            parseData.optIn = false;
          }
          if(parseData) {
            parseData.typeCode = 'Caesars';
          }
          formData = JSON.stringify(parseData);
        } else {
          formData = Form.serialize($form, false, opts.ignoredInputs);
        }
        const submitButton = e.target.querySelector('button.submit');
        window.AdobeWebSdk && window.AdobeWebSdk.onClaimAndLoyaltyFormSuccessRewardsPage(submitButton, opts.url);
        Spinner.appendTo($form);
        Form.disableFormField($form.find('.submit'));
        formData = JSON.parse(formData);
        formData.memberIdentifier = this.$memberIdentifier.eq(0).text();

        if (typeof cbs.setPayload === 'function') {
          cbs.setPayload($form, formData);
        }

        if (opts.url.endsWith('/claimPointPack')
        || opts.url.endsWith('/claimPointPack/count-on-me')) {
          delete formData.accountNumber;
        }

        $.ajax({
          url: opts.url,
          type: opts.type || 'POST',
          dataType: opts.dataType || 'json',
          contentType: opts.contentType || 'application/json',
          data: JSON.stringify(formData),
          context: {
            onFail: {
              formElement: $form
            }
          },
          success: (response) => {
            UserHandler.getProfile(() => {
              this.scrollToTop();
              Form.handleSuccessContainer({
                preSuccessSelector: '.authenticationcontainer'
              });

              if (typeof cbs.success === 'function') {
                cbs.success(response);
              }
              EventHandler.triggerEvent('claim-form_success', this.getAnalyticsFormSuccessObj($form,formData, response));
            });
          },
          error: (e) => {
            if (e.responseJSON && e.responseJSON.ErrorMessage) {
              const errorMessage = e.responseJSON.ErrorCode && e.responseJSON.ErrorCode === '0001' && e.responseJSON.InternalErrorMessage ? 
              e.responseJSON.InternalErrorMessage.replace('\"partnerAccountNumber\"', 'Partner Account Number') : e.responseJSON.ErrorMessage;

              setTimeout(() => {
                $form.find('.form-error.help-block').hide();
                $form.find('#form-error-message').html(errorMessage).show();
              }, 100);
            }

            if (typeof cbs.error === 'function') {
              cbs.error(e);
            }
          }
        });

      });
  }

  initCompetitorStatusForm($form, opts, cbs) {
    cbs = cbs || {};
    $('.page').addClass('status-match-page');
    $form.formValidation(opts.validation)
      .on('err.form.fv', () => {
        Form.scrollToInputError();
      })
      .on('success.form.fv', (e) => {
        e.preventDefault();
        if ($('#fileId').hasClass('required') && (this.$file.length == 0 || this.$file.size <= 0)) {
          this.clearFileUploadErrors();
          this.showFileUploadError('.help-block.file-empty');
          return;
        }

        Spinner.appendTo($form);
        Form.disableFormField($form.find('.submit'));
        let uuid = 'xxxxxxxx-xxxx-yxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
        if(this.$file && this.$file.name != undefined) {
          let $this = this;
          
          $.ajax({
            type: 'post',
            processData: false,
            contentType: this.$file.type,
            data: window.fileData,
            url: requestUrls.wrFileUpload + "?uniq=" + uuid + "&filename=" + this.$file.name,
            context: {
              onFail: {
                analyticsEvent: 'contact-us-form_error',
                scrollToElement: $form,
                formElement: $form
              }
            }
          }).always(function(jqXHR) {
            if (jqXHR.status === 200) 
              $this.submitContactUsForm($form,uuid,$this.$file.name);
          });
        } else {
          this.submitContactUsForm($form,'','');
        }
      });
  }
  submitContactUsForm($form,uuid,fileName) {
    let file = {}, sampleForm = {};
    this.createValue(file, 'key', uuid + '/' + fileName);
    (fileName.length > 0) ? this.createValue(file, 'key', uuid + '/' + fileName) : this.createValue(file, 'key', '');
    sampleForm = {
      'formdata':this.createRequestJSON(Form.serialize($form, true)),
      'fileinfo':file
    };
    
    $.ajax({
      type: 'post',
      url: requestUrls.wrContactUs,
      processData: false,
      data: JSON.stringify(sampleForm),
      cache: false,
      context: {
        onFail: {
          analyticsEvent: 'contact-us-form_error',
          scrollToElement: $form,
          formElement: $form
        }
      },
      success: (response) => {
        UserHandler.getProfile(() => {
          this.scrollToTop();
          Form.handleSuccessContainer({
            preSuccessSelector: '.authenticationcontainer'
          });
        });
      }
    });
  }

  scrollToTop() {
    $('html, body').animate({
      scrollTop: 0
    });
  }

  // ------ FILE UPLOAD FUNCTIONALITY -----
  handleFileUploadClick(event) {
    const href = $(event.target).attr('href');
    if (href && href !== '#') {
      return;
    }
    event.stopPropagation();
    const fileUpload = this.$form.find('#fileId');
    if (fileUpload[0] !== event.target) {
      event.preventDefault();
      fileUpload.click();
    }
  }

  handleFileUpload() {
    const fileUpload = this.$form.find('#fileId')[0];
    const files = fileUpload.files;
    if (files.length > 0) {
      const file = files[0];
      this.$form.find('.file-name').text(file.name);
      this.$form.find('.file-display').removeClass('hidden');
      this.clearFileUploadErrors();
      if (!this.isValidFileSize(file)) {
        this.showFileUploadError('.help-block.file-size');
      } else if (!this.isValidFileType(file)) {
        this.showFileUploadError('.help-block.file-type');
      } else {
        this.$file = file;
        let reader = new FileReader();
        reader.readAsArrayBuffer(this.$file);
        reader.onload = function() {
          window.fileData = reader.result;
        };
        this.$form.find('.file-upload').addClass('hidden')
          .removeClass('hidden-xs');
      }
    }
  }

  resetFileUpload(event) {
    event.preventDefault();
    const fileUpload = this.$form.find('#fileId');
    fileUpload.replaceWith(fileUpload.val('').clone());
    this.$form.find('.file-display').addClass('hidden');
    this.$form.find('.file-name').text('');
    this.$form.find('.file-upload').removeClass('hidden')
      .addClass('hidden-xs');
    this.clearFileUploadErrors();
  }

  clearFileUploadErrors() {
    this.$form.find('.file-upload .form-group').removeClass('has-error');
    this.$form.find('.file-display .form-group').removeClass('has-error');
    this.$form.find('.help-block.file-size').hide();
    this.$form.find('.help-block.file-type').hide();
    this.$form.find('.help-block.file-empty').hide();
  }

  showFileUploadError(selector) {
    this.$form.find('.file-upload .form-group').addClass('has-error');
    this.$form.find('.file-display .form-group').addClass('has-error');
    this.$form.find(selector).show();
    Form.scrollToInputError();
  }

  isValidFileSize(file) {
    return file.size < 5242880;
  }

  isValidFileType(file) {
    for (let fileType of fileTypes) {
      if (file.type === fileType)
        return true;
    }
    for (let fileExtension of fileExtensions) {
      if (fileExtension.test(file.name))
        return true;
    }
    return false;
  }

  createValue(obj, property, value) {
    if (value) {
      obj[property] = value;
    }
  }

  createSubValue(obj, property, subProperty, value) {
    if (value) {
      obj[property] = obj[property] || {};
      this.createValue(obj[property], subProperty, value);
    }
  }

  createRequestJSON(serializedForm) {
    let obj = {};
    if (typeof serializedForm === 'undefined' || !serializedForm) {
      return obj;
    }
    this.createValue(obj, 'firstName', window.User.firstName);
    this.createValue(obj, 'lastName', window.User.lastName);
    this.createValue(obj, 'contactType', 'SM');
    this.createSubValue(obj, 'statusMatch', 'competitorProgram', serializedForm.competitorProgramName);
    this.createSubValue(obj, 'statusMatch', 'level', serializedForm.programStatus);
    this.createValue(obj, 'comment', serializedForm.comment);
    this.createValue(obj, 'memberNumber', serializedForm.memberNumber);
    this.createValue(obj, 'email', serializedForm.emailAddress);
    return obj;
  }

  addClassName(element, value) {
    if (element && element.parentNode && element.parentNode.parentNode) {
      element.parentNode.parentNode.classList.add(value);
    }
  }

  removeFormFieldBorder(){
    this.addClassName(document.getElementById('zipCode0'), 'remove-top-border');
    this.addClassName(document.getElementById('caesarsMemberNumber'), 'remove-bottom-border');
  }

  // ----- ANALYTICS -----
  getAnalyticsFormSuccessObj($form, formData) {
    if(this.isMilitary){
      window.digitalData.rewards.claim.claimType = 'military';
      return {
        type: 'military'
      };
    } else {
      switch ($form) {
        case this.$goldPassForm:
          return {
            type: 'goldPass'
          };
        case this.$wwaForm:
          return {
            type: 'wwa'
          };
        case this.$wvoForm:
          return {
            type: 'wvo'
          };
        case this.$claimPointsForm:
          return {
            type: 'claimPoints',
            data: {
              voucher: formData.couponCode
            }
          };
        case this.$caesarsStatusMatch:
          return {
            type: 'caesarsStatusMatch',
            data: {
              partner: '',
              subscribeEStatements: ''
            }
          };
        case this.$loyaltyStatusMatch:
          return {
            type: 'loyaltyStatusMatch',
            data: {
              partner: '',
              subscribeEStatements: ''
            }
          };
        default:
          return null;
      }
    }
  }
}

export default new Claim();
